import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import {initReactI18next} from 'react-i18next';

import * as en from './locales/en';
import * as bn from './locales/bn';

i18n.use(LanguageDetector).use(initReactI18next).init({
    keySeparator: '.',
    interpolation: {
        escapeValue: false, // not needed for react!!
        formatSeparator: ","
    },
    fallbackLng: "en",
    debug: false,
    react: {
        wait: true,
    },
    ns: ['messages'],
    defaultNS: 'messages',
    fallbackNS: [],
    resources: {
        en: {messages: en},
        bn: {messages: bn},
    }
}).then(() => {
    // console.log('i18n.init')
})

export default i18n;